import styled from "styled-components";

const GameCardJacquette = styled.img`
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  width: 100%;
  max-height: 100%;
`;

export default GameCardJacquette;
